module.exports = __webpack_public_path__ + "media/images/feature-3-56e70c92.png";